module.exports = __webpack_public_path__ + "img/welcomebank.777af1a8.png";